export default "__VITE_ASSET__CFyf6Px4__"